var _excluded = ["id", "items", "hoverIndex", "itemRole", "onItemSelect", "onHover", "role"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { DropdownSelfControlledPopup } from './DropdownPopup';
import { DropdownList } from './DropdownList';
import { DropdownItem } from './DropdownItem';

/**
 * Меню dropdown, выводящее текущий список и все вложенные в него списки в popup.
 */
export var DropdownMenu = function DropdownMenu(_ref) {
  var id = _ref.id,
      items = _ref.items,
      hoverIndex = _ref.hoverIndex,
      itemRole = _ref.itemRole,
      onItemSelect = _ref.onItemSelect,
      onHover = _ref.onHover,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'menu' : _ref$role,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(DropdownList, _extends({}, rest, {
    id: id,
    role: role
  }), items.map(function (item, i) {
    return item.items && item.items.length ? /*#__PURE__*/React.createElement(DropdownSelfControlledPopup, {
      role: "presentation",
      key: item.value,
      id: id ? "".concat(id, "-nested-").concat(i) : id,
      trigger: "hover",
      placement: "right",
      disclosure: /*#__PURE__*/React.createElement(DropdownItem, _extends({}, item, {
        id: id ? "".concat(id, "-item-").concat(i) : id,
        role: itemRole,
        isHovered: i === hoverIndex,
        index: i,
        onClick: onItemSelect,
        onHover: onHover
      }))
    }, /*#__PURE__*/React.createElement(DropdownMenu, {
      items: item.items,
      onItemSelect: onItemSelect
    })) : /*#__PURE__*/React.createElement(DropdownItem, _extends({}, item, {
      key: item.value,
      id: id ? "".concat(id, "-item-").concat(i) : id,
      role: itemRole,
      isHovered: i === hoverIndex,
      index: i,
      onClick: onItemSelect,
      onHover: onHover
    }));
  }));
};